import React, { useEffect } from "react";

import NavBar from "../components/common/navBar";
import Logo from "../components/common/logo";
import INFO from "../data/user";

import "./styles/404.css";

const Notfound = () => {
	useEffect(() => {
		document.title = `404 | ${INFO.main.title}`;
	}, []);

	return (
		<React.Fragment>
			<div className="not-found page-content">
				<NavBar />
				<div className="content-wrapper">
					<div className="not-found-logo-container">
						<div className="not-found-logo">
							<Logo width={40} />
						</div>
					</div>
					<div className="not-found-container">
						<div className="not-found-message">
							<div className="title not-found-title">
								Oops!
							</div>
							<div className="subtitle not-found-subtitle">
								We can't seem to find the page you're looking
								for.
								<br />
								The requested URL "{window.location.href}" was
								not found on this server.
							</div>
							<a href="/" className="not-found-link">
								Go back to the home page
							</a>
						</div>
					</div>

					<div className="page-footer">
						<div className="copyright">
							{INFO.copyright}
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Notfound;
